import Select from '../../../../CMSComponent/Forms/Fields/select'
import { primary_color } from '../../../../Helper/uiHelper'

const QueryType = ({ field, isEditMode, selectedQueryType, setUpdatedData }) => {
  if (isEditMode && field) {
    return (
      <Select
        data={field}
        isTable={true}
        value={selectedQueryType?.id}
        inputLabel={selectedQueryType?.name}
        noCache
        onChangeValue={(id, value) => {
          setUpdatedData((data) => {
            return {
              ...data,
              query_type_id: value,
            }
          })
        }}></Select>
    )
  }
  return <div className='subtitle1 text-muted'>{selectedQueryType?.name}</div>
}
export default QueryType
